import { render, staticRenderFns } from "./RegisterAccount.vue?vue&type=template&id=5f6cb0c6&scoped=true"
import script from "./RegisterAccount.vue?vue&type=script&lang=js"
export * from "./RegisterAccount.vue?vue&type=script&lang=js"
import style0 from "./RegisterAccount.vue?vue&type=style&index=0&id=5f6cb0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6cb0c6",
  null
  
)

export default component.exports